import { FlexAlignCenter } from 'components/primitives/flex';
import { useCallback } from 'react';
import styled from 'styled-components';

export default function ToggleMapSwitch({ isMapVisible, toggleMap }) {
  const handleToggleMap = useCallback(() => {
    toggleMap();
  }, [toggleMap]);

  return (
    <Switch onClick={handleToggleMap}>
      <SwitchState active={isMapVisible}>Map on</SwitchState>
      <SwitchState active={!isMapVisible}>Map off</SwitchState>

      <Indicator isMapVisible={isMapVisible} />
    </Switch>
  );
}

const Switch = styled(FlexAlignCenter)`
  justify-content: space-around;
  border: 1px solid rgba(190, 190, 190, 0.7);
  border-radius: 60px;
  font-weight: 500;
  font-size: 14px;
  padding: 0 4px;
  position: relative;
  height: 36px;
`;

const SwitchState = styled(FlexAlignCenter)<{ active: boolean }>`
  color: ${({ active }) => (active ? '#fff' : '#17233C')};
  transition: color 0.2s;
  position: relative;
  z-index: 1;
  text-align: center;
  flex: 1;
  white-space: nowrap;
  padding: 0px 10px;
  cursor: pointer;
  height: 100%;
`;

const Indicator = styled.div<{ isMapVisible: boolean }>`
  background: #1e53bb;
  border: 1px solid #1e53bb;
  border-radius: 67px;
  position: absolute;
  top: 3px;
  bottom: 3px;
  left: 4px;
  width: calc(50% - 4px);
  transition: transform 0.2s;
  ${({ isMapVisible }) => !isMapVisible && 'transform: translateX(100%)'};
`;
